export default __webpack_public_path__ + "static/media/card_logo_visa.7f986d7a.png";